module.exports = __webpack_public_path__ + "static/media/link_add.f4905102.svg";